module.exports = __webpack_public_path__ + "static/media/outline-p4-white2.5d7feff8.png";